import ApiBase from '@/api/ApiBase';

export default class Quotations extends ApiBase {
  get(options = {}) {
    return this.request('GET', 'quotations', { ...options });
  }
}
